import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { IHistory } from '../../interfaces';
import { PlantModel } from '../../model/PlantModel';

interface IListItemProps {
    instance: PlantModel;
    onClick: Function;
    index: number;
    history: IHistory;
}

export class ListItemImpl extends React.Component<IListItemProps, {}> {

    static defaultProps: IListItemProps;

    render() {
        const { instance, index, history } = this.props;
        if (!instance) {
            return '';
        }
        return <Row className="form-list-item" >
            <Col
                onClick={() => history.push(`/maintenance/${instance.props.id}/${instance.props.PlantId}`)}
                className="clickable-list-item" xs={3}
                sm={4}
            >
                {instance.props.PlantId}

            </Col>
            <Col
                onClick={() => history.push(`/maintenance/${instance.props.id}/${instance.props.PlantId}`)}
                className="clickable-list-item" xs={4}
                sm={4}
            >
                {instance.props.Plant_Region}
            </Col>
            <Col
                onClick={() => history.push(`/maintenance/${instance.props.id}/${instance.props.PlantId}`)}
                className="clickable-list-item" xs={3}
                sm={4}
            >
                {instance.props.State}
            </Col>
        </Row>;
    }
}

export function mapStateToProps(state) {
    return {
        state
    };
}

export const ListItem = withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Maintenance/ListItem.tsx